import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/cart.png'


const _hoisted_1 = {
  id: "signed-in-component",
  class: "text-white border-start h-100 ps-3 fs-5 border-secondary"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = {
  class: "col",
  id: "email"
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = {
  key: 0,
  class: "row mt-4"
}
const _hoisted_8 = { class: "col" }
const _hoisted_9 = {
  id: "cart-img-container",
  class: "position-relative"
}
const _hoisted_10 = ["textContent"]
const _hoisted_11 = {
  key: 0,
  class: "position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.email), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", {
        class: "col text-decoration-underline",
        id: "user-disconnect-text",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickedDisconnect && _ctx.clickedDisconnect(...args)))
      }, _toDisplayString(_ctx.disconncect), 1)
    ]),
    (_ctx.hasCartAccess)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("img", {
                alt: "Marlyse Photo",
                id: "user-cart-img",
                class: "ms-2 mb-4",
                src: _imports_0,
                textContent: _toDisplayString(_ctx.email),
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickedCart && _ctx.clickedCart(...args)))
              }, null, 8, _hoisted_10),
              (_ctx.totalInCart > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.totalInCart), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}